export default __webpack_public_path__ + "static/media/iconGridTres.51d185ef.png";